import { GetterTree } from 'vuex'

import { RootState } from '../state'
import invoicesGetters from './invoices/getters'
import ordersGetters from './orders/getters'
import orderPaymentsGetters from './orderPayments/getters'
import { OrderingState } from './state'

const getters: GetterTree<OrderingState, RootState> = {
  ...invoicesGetters,
  ...ordersGetters,
  ...orderPaymentsGetters
}

export default getters
